/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated.js';
import { createTau } from '../../factoriesAny.js';
export var tauDependencies = {
  BigNumberDependencies,
  createTau
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/esm/entry/dependenciesAny/dependenciesTau.generated.js
// module id = null
// module chunks = 